<template>
    <el-container  >
        <el-row class="home">
            <div style="position: absolute;transform: translate(-50%,-50%);left:50%;top: 20%" v-if="!isSearch">
                <img src="@/assets/logo_big.png" style="left:0;float: left">
                <div style="float: left;padding-left: 3rem;line-height: 8rem;font-size: 5.5rem;color: #0f53a7">
                    用水定额
                </div>
            </div>
            <div style="position: absolute;transform: translate(0,-50%);left:2%;top: 8%" v-if="isSearch">
                <img src="@/assets/logo_small.png" >
                <div style="line-height: 4rem;font-size:2.1rem;font-weight:550;color: #0f53a7">
                    用水定额
                </div>
            </div>

            <div style="position: absolute;width: 55%;height: 5rem;"
                 :style="{left:isSearch ? '10%' : '25%',top:isSearch ? '3%' : '28%'}" >
                <div class="xzsj2" >
                    <div class="pointer sjbutton2"
                         :class="selectd === 'kj' ? 'buttonSeletd' : 'sjbutton2'" @click="changeSearch('kj')">快捷</div>
                    <div class="pointer sjbutton2" style="margin-left: 10px"
                         :class="selectd === 'jz' ? 'buttonSeletd' : 'sjbutton2'" @click="changeSearch('jz')">精准</div>
                </div>
                <div style="height: 5rem;" v-if="selectd==='kj'" id="myinput">
                    <el-input placeholder="请输入关键词检索   例如：粗钢" v-model="form.keyword" style="height: 5rem;padding-top: 1rem" >
                        <template slot="prepend">
                            <img src="@/assets/cx.png" style="left:0;float: left">
                        </template>
                        <div slot="append" @click="quickSeach">搜定额</div>
                    </el-input>
                </div>
            </div>
            <div v-if="selectd==='jz' && !isSearch" style="position: absolute;transform: translate(-50%,-50%);width: 55%;height: 35rem;top: 52%;left: 52%">
                <div class="xzsj2" style="padding: 2rem;margin-top: 1rem;width: 80%;float: left;height: 40rem;background-color:#ffffff; border-radius: 10px;border: solid 1px #ebeff3;">
                    <div class="pointer sjbutton1"
                         :class="form.indSelectd === '01' ? 'buttonSeletd2' : 'sjbutton1'" @click="changeInd('01')">工业
                    </div>
                    <div class="pointer sjbutton1" style="margin-left: 1rem"
                         :class="form.indSelectd === '02' ? 'buttonSeletd2' : 'sjbutton1'"  @click="changeInd('02')">服务业
                    </div>
                    <div class="pointer sjbutton1" style="margin-left: 1rem"
                         :class="form.indSelectd === '03' ? 'buttonSeletd2' : 'sjbutton1'" @click="changeInd('03')">农业
                    </div>
                    <div class="pointer sjbutton1" style="margin-left: 1rem"
                         :class="form.indSelectd === '06' ? 'buttonSeletd2' : 'sjbutton1'" @click="changeInd('06')">公共机构
                    </div>
                    <div class="pointer sjbutton1" style="margin-left: 1rem"
                         :class="form.indSelectd === '05' ? 'buttonSeletd2' : 'sjbutton1'" @click="changeInd('05')">其他行业
                    </div>

                  <div v-show="form.indSelectd === '01'" style="height: 200px;margin-top: 6rem;">
                    <div style="text-align: left;display: flex;align-items: center;" >
                      <span style="font-weight: bold;font-size: 14px;">行业</span>
                      <span
                          v-for="item in zdhyList"
                          :key="item"
                          :class="form.zdhy === item ? 'list list-checked' : 'list'"
                          @click="form.zdhy = item">
                        {{item}}
                      </span>
                    </div>

                    <div style="margin-top: 3rem;text-align: left;display: flex;align-items: center;" >
                      <span style="font-weight: bold;margin-right: 10px;">更多</span>
                      <el-select v-model="form.bz" placeholder="请选择" class="bz-select" clearable>
                        <el-option
                            v-for="item in standards"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div v-show="form.indSelectd === '02'" style="height: 200px;margin-top: 6rem;">
                    <div style="text-align: left;display: flex;align-items: center;" >
                      <span style="font-weight: bold;font-size: 14px;">分类</span>
                      <span
                          v-for="item in flList"
                          :key="item"
                          :class="form.fl === item ? 'list list-checked' : 'list'"
                          @click="form.fl = item">
                        {{item}}
                      </span>
                    </div>

                    <div style="margin-top: 3rem;text-align: left;display: flex;align-items: center;" >
                      <span style="font-weight: bold;margin-right: 10px;">更多</span>
                      <el-select v-model="form.bz" placeholder="请选择" class="bz-select" clearable>
                        <el-option
                            v-for="item in standards"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div v-show="form.indSelectd === '03'" style="height: 200px;margin-top: 6rem;">
                    <div style="margin-top: 6rem;text-align: left;display: flex;align-items: center;" >
                      <span style="font-weight: bold;font-size: 14px;">水文年</span>
                      <span
                          v-for="item in swnList"
                          :key="item"
                          :class="form.swn === item ? 'list list-checked' : 'list'"
                          @click="form.swn = item">
                        {{item}}
                      </span>
                    </div>
                    <div style="margin-top: 1rem;text-align: left;display: flex;align-items: center;" >
                      <span style="font-weight: bold;font-size: 14px;">茬口</span>
                      <span
                          v-for="item in ckList"
                          :key="item"
                          :class="form.ck === item ? 'list list-checked' : 'list'"
                          @click="form.ck = item">
                        {{item}}
                      </span>
                    </div>
                    <div style="margin-top: 1rem;text-align: left;display: flex;align-items: center;" >
                      <span style="font-weight: bold;font-size: 14px;">灌溉方式</span>
                      <span
                          v-for="item in ggList"
                          :key="item"
                          :class="form.ggfs === item ? 'list list-checked' : 'list'"
                          @click="form.ggfs = item">
                        {{item}}
                      </span>
                    </div>
                    <div style="margin-top: 1rem;text-align: left;display: flex;align-items: center;" >
                      <span style="font-weight: bold;margin-right: 10px;">更多</span>
                      <el-select v-model="form.bz" placeholder="标准" class="bz-select" style="margin-right: 10px;" clearable>
                        <el-option
                            v-for="item in standards"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                      </el-select>

                      <el-select v-model="form.gq" placeholder="灌区" class="bz-select" style="margin-right: 10px;" @change="getDeGgFqOptions">
                        <el-option
                            v-for="item in deGgOptions"
                            :key="item.gqbh"
                            :label="item.gqmc"
                            :value="item.gqbh">
                        </el-option>
                      </el-select>

                      <el-select v-model="form.ggfq" placeholder="灌溉分区" class="bz-select" style="margin-right: 10px;">
                        <el-option
                            v-for="item in deGgFqOptions"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                        </el-option>
                      </el-select>
                    </div>
                  </div>

                  <div v-show="form.indSelectd === '06'" style="height: 200px;margin-top: 6rem;">
                    <div style="text-align: left;display: flex;align-items: center;" >
                      <span style="font-weight: bold;font-size: 14px;">分类</span>
                      <span
                          v-for="item in ggflList"
                          :key="item"
                          :class="form.ggfl === item ? 'list list-checked' : 'list'"
                          @click="form.ggfl = item">
                        {{item}}
                      </span>
                    </div>

                    <div style="margin-top: 3rem;text-align: left;display: flex;align-items: center;" >
                      <span style="font-weight: bold;margin-right: 10px;">更多</span>
                      <el-select v-model="form.bz" placeholder="请选择" class="bz-select" clearable>
                        <el-option
                            v-for="item in standards"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>

                  <div v-show="form.indSelectd === '05'" style="height: 200px;margin-top: 6rem;">
                    <div style="margin-top: 3rem;text-align: left;display: flex;align-items: center;" >
                      <span style="font-weight: bold;margin-right: 10px;">更多</span>
                      <el-select v-model="form.bz" placeholder="请选择" class="bz-select" clearable>
                        <el-option
                            v-for="item in standards"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>

                    <div style="margin-top: 2rem;" id="myselect2">
                        <el-input v-model="form.keyword" slot="prepend" placeholder="搜索您要查询的定额" style="width: 100%;" @keyup.enter="query">

                        </el-input>
                    </div>
                    <div class="pointer deSearchButton" @click="query" style="position: relative;transform: translate(-50%,-50%);left: 50%;top:4rem;float: left">
                        搜定额
                    </div>
                    <div class="pointer" style="float: left;padding-left: 32rem;padding-top: 2rem;font-size: 1.4rem;color: #707070" @click="cz">
                        <img src="@/assets/cz.png" style=""/>
                        重置搜索条件
                    </div>
                </div>
            </div>

            <div v-if="selectd==='jz' && isSearch" style="position: relative;width: calc(80% - 5rem);height: 26rem;top: 8%;left: 10%"
                 :style="{height:!show.fdFlag ? '10rem' : '26rem'}">
                <div class="xzsj2" style="padding: 2rem;margin-top: 1rem;width: 100%;float: left;height: 22rem;background-color:#ffffff; border-radius: 10px;border: solid 1px #ebeff3;"
                     :style="{height:!show.fdFlag ? '10rem' : '22rem'}">
                   <el-col :span="20">
                       <div class="pointer sjbutton1"
                            :class="form.indSelectd === '01' ? 'buttonSeletd2' : 'sjbutton1'" @click="changeInd('01')">工业
                       </div>
                       <div class="pointer sjbutton1" style="margin-left: 1rem"
                            :class="form.indSelectd === '02' ? 'buttonSeletd2' : 'sjbutton1'" @click="changeInd('02')">服务业
                       </div>
                       <div class="pointer sjbutton1" style="margin-left: 1rem"
                            :class="form.indSelectd === '03' ? 'buttonSeletd2' : 'sjbutton1'" @click="changeInd('03')">农业
                       </div>
                       <div class="pointer sjbutton1" style="margin-left: 1rem"
                            :class="form.indSelectd === '06' ? 'buttonSeletd2' : 'sjbutton1'" @click="changeInd('06')">公共机构
                       </div>
                       <div class="pointer sjbutton1" style="margin-left: 1rem"
                            :class="form.indSelectd === '05' ? 'buttonSeletd2' : 'sjbutton1'" @click="changeInd('05')">其他行业
                       </div>

                     <el-row v-show="form.indSelectd === '01' && show.fdFlag" style="height: 100px;margin-top: 6rem;">
                       <el-col :span="12" style="text-align: left;display: flex;align-items: center;" >
                         <span style="font-weight: bold;font-size: 14px;">行业</span>
                         <span
                             v-for="item in zdhyList"
                             :key="item"
                             :class="form.zdhy === item ? 'list list-checked' : 'list'"
                             @click="changeZdhy(item)">
                        {{item}}
                      </span>
                       </el-col>

                       <el-col  :span="12" style="text-align: left;display: flex;align-items: center;" >
                         <span style="font-weight: bold;margin-right: 10px;">更多</span>
                         <el-select v-model="form.bz" placeholder="请选择" class="bz-select" clearable @change="query">
                           <el-option
                               v-for="item in standards"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                           </el-option>
                         </el-select>
                       </el-col>
                     </el-row>
                     <el-row v-show="form.indSelectd === '02' && show.fdFlag" style="height: 100px;margin-top: 6rem;">
                       <el-col :span="12" style="text-align: left;display: flex;align-items: center;" >
                         <span style="font-weight: bold;font-size: 14px;">分类</span>
                         <span
                             v-for="item in flList"
                             :key="item"
                             :class="form.fl === item ? 'list list-checked' : 'list'"
                             @click="changeFl(item)">
                          {{item}}
                        </span>
                       </el-col>

                       <el-col :span="12" style="text-align: left;display: flex;align-items: center;" >
                         <span style="font-weight: bold;margin-right: 10px;">更多</span>
                         <el-select v-model="form.bz" placeholder="请选择" class="bz-select" clearable @change="query">
                           <el-option
                               v-for="item in standards"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                           </el-option>
                         </el-select>
                       </el-col>
                     </el-row>
                     <el-row v-show="form.indSelectd === '03' && show.fdFlag" style="height: 100px;margin-top: 6rem;">
                       <el-col :span="12" style="text-align: left;display: flex;align-items: center;" >
                         <span style="font-weight: bold;font-size: 14px;">水文年</span>
                         <span
                             v-for="item in swnList"
                             :key="item"
                             :class="form.swn === item ? 'list list-checked' : 'list'"
                             @click="changeSwn(item)">
                          {{item}}
                        </span>
                       </el-col>
                       <el-col :span="12" style="text-align: left;display: flex;align-items: center;" >
                         <span style="font-weight: bold;font-size: 14px;">茬口</span>
                         <span
                             v-for="item in ckList"
                             :key="item"
                             :class="form.ck === item ? 'list list-checked' : 'list'"
                             @click="changeCk(item)">
                        {{item}}
                        </span>
                       </el-col>
                       <el-col :span="12" style="text-align: left;display: flex;align-items: center;" >
                         <span style="font-weight: bold;font-size: 14px;">灌溉方式</span>
                         <span
                             v-for="item in ggList"
                             :key="item"
                             :class="form.ggfs === item ? 'list list-checked' : 'list'"
                             @click="changeGgfs(item)">
                        {{item}}
                      </span>
                       </el-col>
                       <el-col :span="12" style="text-align: left;display: flex;align-items: center;" >
                         <span style="font-weight: bold;margin-right: 10px;">更多</span>
                         <el-select v-model="form.bz" placeholder="标准" class="bz-select" style="margin-right: 10px;" clearable @change="query">
                           <el-option
                               v-for="item in standards"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                           </el-option>
                         </el-select>

                         <el-select v-model="form.gq" placeholder="灌区" class="bz-select" style="margin-right: 10px;" @change="getDeGgFqOptions">
                           <el-option
                               v-for="item in deGgOptions"
                               :key="item.gqbh"
                               :label="item.gqmc"
                               :value="item.gqbh">
                           </el-option>
                         </el-select>

                         <el-select v-model="form.ggfq" placeholder="灌溉分区" class="bz-select" style="margin-right: 10px;" @change="query">
                           <el-option
                               v-for="item in deGgFqOptions"
                               :key="item.code"
                               :label="item.name"
                               :value="item.code">
                           </el-option>
                         </el-select>
                       </el-col>
                     </el-row>
                     <el-row v-show="form.indSelectd === '06' && show.fdFlag" style="height: 100px;margin-top: 6rem;">
                       <el-col :span="12" style="text-align: left;display: flex;align-items: center;" >
                         <span style="font-weight: bold;font-size: 14px;">分类</span>
                         <span
                             v-for="item in ggflList"
                             :key="item"
                             :class="form.ggfl === item ? 'list list-checked' : 'list'"
                             @click="changeGgfl(item)">
                          {{item}}
                        </span>
                       </el-col>

                       <el-col :span="12" style="text-align: left;display: flex;align-items: center;" >
                         <span style="font-weight: bold;margin-right: 10px;">更多</span>
                         <el-select v-model="form.bz" placeholder="请选择" class="bz-select" clearable @change="query">
                           <el-option
                               v-for="item in standards"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                           </el-option>
                         </el-select>
                       </el-col>
                     </el-row>
                     <el-row v-show="form.indSelectd === '05' && show.fdFlag" style="height: 100px;margin-top: 6rem;">
                       <el-col :span="12" style="text-align: left;display: flex;align-items: center;" >
                         <span style="font-weight: bold;margin-right: 10px;">更多</span>
                         <el-select v-model="form.bz" placeholder="请选择" class="bz-select" clearable @change="query">
                           <el-option
                               v-for="item in standards"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                           </el-option>
                         </el-select>
                       </el-col>
                     </el-row>
                     <div style="" id="myselect2" v-if="show.fdFlag">
                         <el-input v-model="form.keyword" slot="prepend" placeholder="搜索您要查询的定额" style="width: 99%;float: left !important;" @keyup.enter.native="query">

                         </el-input>
                     </div>
                   </el-col>
                   <el-col :span="4">
                       <div class="pointer deSearchButton" @click="query" style="margin-top: 5rem; width: 100%;height: 17rem;line-height: 17rem"
                            :style="{height:!show.fdFlag ? '10rem' : '17rem',marginTop:!show.fdFlag ? '0' : '5rem',lineHeight:!show.fdFlag ? '10rem' : '17rem'}">
                           搜定额
                       </div>
                   </el-col>
                    <div class="pointer" @click="show.fdFlag = !show.fdFlag" style="position: absolute;left:45%;top: 25rem" v-if="isSearch && show.jkcx && show.fdFlag">
                        <img src="@/assets/sx.png" >
                    </div>

                    <div class="pointer" @click="show.fdFlag = !show.fdFlag" style="position: absolute;left:45%;top: 13rem" v-if="isSearch && show.jkcx && !show.fdFlag">
                        <img src="@/assets/fd.png" >
                    </div>
                </div>
            </div>
            <div style="position: relative;left:10%;top: 15%;width: 80%;height: 75%;overflow:auto;overflow-x: hidden"
                  v-if="isSearch" :style="{top:(isSearch && selectd==='jz') ? '9%' : '15%',height:(isSearch && selectd==='jz') ? show.fdFlag ? '50%' : '64%' : '75%'}">
                <div v-if="show.zw" style="height: 100%;width: 100%">
                    <img src="@/assets/zw.png" />
                </div>
                <div v-for="(item,index) of data" style="width: 100%;border: 1px solid #f5f5f5;border-radius: 4px;">
                    <div style="width: 100%;height: 3.5rem;background-color: #fdfdfd;line-height: 3.5rem;font-size: 15px;padding: 1rem">
                        <span class="" style="text-align: center;background-color: #1692e7;color: #FFFFFF;display: inline-block;padding: 0 20px">{{ item.indname }}</span>
                        <span style="padding-left: 2rem">{{ item.fullname }}</span>
                    </div>
                    <div  style="border-top: solid 1px #ebeff3;width: 100%;background-color: #fff;color: #707070;font-size: 1.5rem;padding:1rem;" >
                        <el-row v-for="(item_,index_) of item.decodeVOList" :style="{paddingBottom:index_ !== item.decodeVOList ? '1rem' : '0'}" :key="index_">
                            <el-col :span="3" style="padding-left: 1.5rem">
                                <span style="color: #1692e7;font-weight: 700;float: left">{{item_.dename}}</span>
                                <span  style="float: left">：</span>
                                <div v-if="item_.value ? item_.value.length > 30 : false" >
                                    <el-tooltip class="item" effect="dark" :content="item_.value" placement="top-start" style="width: 400px !important;">
                                       <span style="cursor: pointer;color: #46adf5">
                                            {{ item_.value.slice(0,15)+"..."+ item_.value.slice(-15)}}
                                       </span>
                                    </el-tooltip>
                                </div>
                                <div v-else style="float: left">
                                    <span >
                                        {{ item_.value}}
                                   </span>
                                </div>
                            </el-col>
                            <el-col :span="5">
                              <span style="color: #0f53a7;font-weight: 700;">
                                    {{item_.secondPartitionCode}}
                              </span>
                            </el-col>
                            <el-col  :span="16" style="padding-left: 1.5rem">
                                <span style="color: #0f53a7;font-weight: 700;">
                                    {{item_.quotaName}}
                                </span>
                                <span @click="openDrawer(item_)" class="pointer" v-if="item_.gdVOList ? item_.gdVOList.length > 0 : undefined" style="color: #088dff;font-size: 1.4rem">更多</span>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <page-footer
                v-if="isSearch"
                :rForm="form"
                @size-change="sizeChange"
                @current-change="currentChange"
                style="position: absolute;bottom: 4rem;left: 10%;"
            >
            </page-footer>
            <div style="position: absolute;transform: translate(-50%,0);left:50%;bottom: 0%;width: 100%;height: 3rem
                ;text-align: center;color: #6e6f6e;font-size: 1.4rem" >
                <a data-v-0765c3a0="" href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">公网安备110108 02015105号 </a>
                <a data-v-0765c3a0="" href="https://beian.miit.gov.cn" target="_blank" style="padding-left: 2rem">京ICP备14021072号</a>
                <span style="padding-left: 2rem">  版权所有 ◎ 2024北京瀚禹信息科技有限公司</span>
                <span style="padding-right: 2rem;cursor: pointer;float: right;color: #088dff;" @click="gl">管理</span>
            </div>
        </el-row>

        <el-drawer
            title="drawerData.indname+drawerData.dename"
            :visible.sync="drawer"
            :direction="direction"
            :before-close="handleClose">

            <span style="color:#323232;font-size: 1.8rem;padding-left: 2rem">{{drawerData.fullname}}</span>
            <el-divider></el-divider>
            <div style="padding:0 1rem ">
                <div v-for="item of drawerData.gdVOList" style="width: 100%;height: 89px;background-color: #fbfbfb;margin: 1rem 0">
                    <div style="padding: 1rem">
                        <div style="width: 25rem;height: 4rem;background-color: #00b495;text-align: center;font-size:1.5rem;border-radius: 0.5rem;line-height: 4rem;float: left ">
                           <div  v-if="item.partitionName.length > 15">
                               <el-tooltip class="item" effect="dark" :content="item.partitionName" placement="top-start" >
                                <span>
                                     {{ item.partitionName.slice(0,6)+"..."+ item.partitionName.slice(-6)}}
                                </span>
                               </el-tooltip>
                           </div>
                            <span v-else>
                                {{ item.partitionName}}
                           </span>
                        </div>
                        <div style="float: right;font-size:1.5rem;color: #0f53a7;padding-top:1.5rem;">
                            {{ item.quotaName}}
                        </div>
                        <div v-if="item.value ? item.value.length > 30 : false" style="color: #323232;font-size: 1.5rem;padding-top: 5rem;width: 100%">
                            <el-tooltip class="item" effect="dark" :content="item.value" placement="top-start" >
                               <span style="cursor: pointer;width: 100% !important;">
                                    {{ item.value.slice(0,15)+"..."+ item.value.slice(-15)}}
                               </span>
                            </el-tooltip>
                        </div>
                        <div v-else style="color: #323232;font-size: 1.5rem;">
                            <span >
                                {{ drawerData.value}}
                           </span>
                        </div>
                    </div>

                </div>
            </div>
        </el-drawer>
    </el-container>
</template>

<script>
import pageFooter from "@/components/pageFooter";

export default {
  name: "Home",
    components: {
        pageFooter,
    },
    data(){
      return{
        zdhyList: ['不限', '火力发电', '钢铁', '纺织染整', '造纸', '纺织', '食品', '有色金属', '化工'],
        flList: ['不限', '体育场', '图书馆', '娱乐业'],
        swnList: ['不限', '50%', '75%'],
        ckList: ['不限', '一茬', '二茬', '春茬', '夏茬', '秋茬', '越冬茬'],
        ggList: ['不限', '常规灌溉', '膜上灌', '喷灌', '微灌', '渠道防渗灌溉', '管道输水灌溉'],
        ggflList: ['不限', '教育', '医院', '机关'],
        deGgOptions: [],
        deGgFqOptions: [],
          drawer: false,
          direction: 'rtl',
          selectd:"kj",
          isSearch:false,
          data:[],
          form: {
              size: 10,
              current: 1,
              total: 0,
              keyword:'',
              indSelectd:'01',
              // deid:'',
              // decode: '',
              zdhy: '不限',
              bz: '',
              swn: '不限',
              ck: '不限',
              ggfs: '不限',
              gq: '',
              ggfq: '',
              fl: '不限',
              ggfl: '不限'
          },
          wjlist:[],
          show:{
              jkcx:true,//精准查询框
              fdFlag:true,//精准查询框放大按钮
              zw:false,//暂无图片是否显示
          },
          drawerData:[],
          standards: [{
            value: '00101',
            label: '国标'
          }, {
            value: '00102',
            label: '水利部'
          }, {
            value: '00103',
            label: '行标'
          }, {
            value: '00104',
            label: '团标'
          }, {
            value: '00105',
            label: '地标'
          }],
      }
    },
    methods:{
      changeZdhy(val) {
        this.form.zdhy = val;
        this.query();
      },
      changeFl(val) {
        this.form.fl = val;
        this.query();
      },
      changeSwn(val) {
        this.form.swn = val;
        this.query();
      },
      changeCk(val) {
        this.form.ck = val;
        this.query();
      },
      changeGgfs(val) {
        this.form.ggfs = val;
        this.query();
      },
      changeGgfl(val) {
        this.form.ggfl = val;
        this.query();
      },
        getDeGgOptions() {
          this.request.get('/b-irrigate/v1/listAll').then(
              (res) => {
                this.deGgOptions = res.data;
              }
          );
        },
      getDeGgFqOptions(val) {
        this.request.get(`/b-partition/v1/listAllByIrrigate/${val}`).then(
            (res) => {
              this.deGgFqOptions = res.data;
              this.query();
            }
        );
      },
        gl(){
            this.$router.push('/login')
        },
        openDrawer(val){
            this.drawer = true
            this.drawerData = val
            console.log("openDrawer",val)
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => {});
        },
        quickSeach(){
            if(this.form.keyword){
                this.isSearch = true
              this.request.post('/search/v1/queryList', this.form).then(
                  (res) => {
                    this.data = res.data.records
                    this.form.total = res.data.total;
                    if(this.data.length === 0){
                      this.show.zw = true
                    } else {
                      this.show.zw = false
                    }
                  }
              );
            }
        },
        //切花快捷精准
        changeSearch(val){
            this.show.zw = false
            if(this.selectd === val){
                return
            }
            this.selectd =val;
            this.form ={
              size: 10,
              current: 1,
              total: 0,
              keyword:'',
              indSelectd:'01',
              // deid:'',
              // decode: '',
              zdhy: '不限',
              bz: '',
              swn: '不限',
              ck: '不限',
              ggfs: '不限',
              gq: '',
              ggfq: '',
              fl: '不限',
              ggfl: '不限'
            };
            this.data = []
        },
        exactSeach(){
            this.isSearch = true;
            this.request.post('/search/v1/queryList', this.form).then(
                (res) => {
                  this.data = res.data.records
                  this.form.total = res.data.total;
                }
            );
        },
        query() {
          this.form.current = 1;
          this.exactSeach();
        },
        // 切换分页
        currentChange(val) {
            this.form.current = val;
            if(this.selectd === 'kj'){
                this.quickSeach()
            }else{
                this.exactSeach()
            }
        },
        // 显示最大条数变动
        sizeChange(val) {
            this.form.size = val;
            if(this.selectd === 'kj'){
                this.quickSeach()
            }else{
                this.exactSeach()
            }
        },
        //切换行业
        changeInd(val){
            this.form ={
              size: 10,
              current: 1,
              total: 0,
              keyword:'',
              indSelectd: val,
              zdhy: '不限',
              bz: '',
              swn: '不限',
              ck: '不限',
              ggfs: '不限',
              gq: '',
              ggfq: '',
              fl: '不限',
              ggfl: '不限'
            };
            this.data = []
          if (this.isSearch) {
            this.exactSeach();
          }
        },
        //重置
        cz(){
          this.form ={
            size: 10,
            current: 1,
            total: 0,
            keyword:'',
            indSelectd:'01',
            // deid:'',
            // decode: '',
            zdhy: '不限',
            bz: '',
            swn: '不限',
            ck: '不限',
            ggfs: '不限',
            gq: '',
            ggfq: '',
            fl: '不限',
            ggfl: '不限'
          };
        },
    },
  mounted() {
    this.getDeGgOptions();
  }
}

</script>

<style scoped>
.list {
  font-size: 14px;
  cursor: pointer;
  margin-left: 10px;
  color: #323232;
}

.list-checked {
  color: #3478c6;
}

.bz-select ::v-deep .el-input__inner {
  height: 32px;
  width: 135px;
}
</style>

<style lang="less" scoped>
.home{
  width: 100vw;
  height: 100vh;
  background-image: url("../assets/home.png");
  background-repeat: no-repeat;
}

.xzsj2{
    border-radius: 6px;
    width: 100%;
    height: 40px;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    float: right;

}
.buttonSeletd{
    color: #0f53a7;
    background-color: #ffffff !important;
    border-radius: 0.9rem;
    font-weight: 550;
}
.buttonSeletd2{
    color: #fdfdfd;
    background-color: #1692e7 !important;
    border-radius: 6px;
    font-weight: 550;
    float: left;
    width: 9.8rem;
}
.sjbutton1{
    float: left;
    width: calc(100% / 8);
    background-color: #f6f7f8;
}
.sjbutton2{
    float: left;
    background-color: #f6f7f8;
    width: 9.8rem;
    border-radius: 1.8rem;
    font-weight: 550;
}

.pointer{
    cursor: pointer;
}
/deep/ #myinput .el-input__inner {
    height: 5rem;
    border-right: 0px solid #DCDFE6;
}
/deep/  .el-input__inner {
    height: 5rem;
}
/deep/ .el-input-group__append{
    background-color: #0f53a7;
    width: 26rem;
    text-align: center;
    font-weight: 550;
    font-size: 2.2rem;
    color: #ffffff;
    border-radius:0 8px 8px 0;
    //border: solid 1px #ebeff3;
    //border: 1px solid #DCDFE6;
    cursor: pointer;
}
/deep/ .el-drawer__header{
    font-size: 2.5rem;
    color: #1692e7;
}
/deep/ ::-webkit-scrollbar {
    width: 1rem;
    height: 1rem;
}
/deep/ ::-webkit-scrollbar-track {
    --webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 1rem;
}
/deep/ ::-webkit-scrollbar-thumb {
    border-radius: 1rem;
    background: rgb(220, 220, 220);
    --webkit-box-shadow: inset 0 0 1rem rgba(0,0,0,0.5);
}
/deep/ ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(220,220,220,0.4);
}

/deep/ .el-input--mini .el-input__inner{
    height: 28px;
    line-height: 28px;
}
/deep/ .el-input__prefix{
    left:10px;
    height: 0;
}

/deep/ #myselect .el-input__inner{
    padding-left:8rem;
    line-height: 5rem;
}

/deep/ #myselect2 .el-input__inner{
  line-height: 5rem;
}
.deSearchButton{
    width: 26rem;
    height: 6rem;
    background-color: #0f53a7;
    border-radius: 8px;
    border: solid 1px #ebeff3;
    text-align: center;
    line-height: 6rem;
    color: white;
    font-size: 2.2rem;
}
/deep/ .el-divider--horizontal{
    margin: 1rem 0;
}
</style>

<style>
/* 文字过长省略 弹窗的样式 */
/* **************************不加scoped因为 .el-tooltip标签不在这个vue中 */
.el-tooltip__popper{
    width: 60rem !important;
}
</style>
